import ScheduleIcon from './component'

export default ScheduleIcon
